(() => {
  const cartItems = document.querySelector('cart-items');
  const form = document.getElementById('cart');
  if (!cartItems || !form) return;
  let pending = null;
  let allowSubmit = false;
  let lastRefresh = 0;
  let cartRevision = 0;
  const getCheckout = () => document.getElementById('checkout');
  const getStatus = () => document.getElementById('cart-stock-status');

  function syncFooter(incoming) {
    const fresh = incoming.getElementById('cart-stock-status');
    const status = getStatus();
    const freshCheckout = incoming.getElementById('checkout');
    const checkout = getCheckout();
    if (!fresh || !freshCheckout || !status || !checkout) return false;
    status.innerHTML = fresh.innerHTML;
    status.hidden = fresh.hidden;
    status.dataset.cartStockBlocked = fresh.dataset.cartStockBlocked;
    checkout.disabled = freshCheckout.disabled;
    return true;
  }

  function syncLines(incoming) {
    const rows = new Map(Array.from(incoming.querySelectorAll('[data-cart-stock-key]'))
      .map(row => [row.dataset.cartStockKey, row]));
    cartItems.querySelectorAll('[data-cart-stock-key]').forEach(row => {
      const fresh = rows.get(row.dataset.cartStockKey)?.querySelector('[data-cart-stock-message]');
      const message = row.querySelector('[data-cart-stock-message]');
      if (fresh && message) {
        message.innerHTML = fresh.innerHTML;
        message.hidden = fresh.hidden;
      }
    });
  }

  async function refresh() {
    if (pending) return pending;
    if (cartItems.getAttribute('aria-busy') === 'true') return false;
    const itemsId = document.getElementById('main-cart-items')?.dataset.id;
    const footerId = document.getElementById('main-cart-footer')?.dataset.id;
    if (!itemsId || !footerId) return false;
    const revision = cartRevision;
    pending = (async () => {
      const url = new URL(window.routes.cart_url, window.location.origin);
      url.searchParams.set('sections', [itemsId, footerId].join(','));
      url.searchParams.set('_stock_check', String(Date.now()));
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Availability check failed');
      const sections = await response.json();
      if (!sections[itemsId] || !sections[footerId]) throw new Error('Missing cart sections');
      // Avoid applying an old check while a quantity update is in progress.
      if (cartItems.getAttribute('aria-busy') === 'true' || revision !== cartRevision) return false;
      const parser = new DOMParser();
      syncLines(parser.parseFromString(sections[itemsId], 'text/html'));
      if (!syncFooter(parser.parseFromString(sections[footerId], 'text/html'))) return false;
      lastRefresh = Date.now();
      return true;
    })().finally(() => { pending = null; });
    return pending;
  }

  function checkWhenReturning() {
    if (!document.hidden && Date.now() - lastRefresh > 10000) refresh().catch(() => {});
  }
  window.TTHCartStock = { syncFooter, refresh, invalidate: () => { cartRevision++; } };
  window.addEventListener('focus', checkWhenReturning);
  window.addEventListener('pageshow', checkWhenReturning);
  document.addEventListener('visibilitychange', checkWhenReturning);
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-cart-stock-refresh]');
    if (!trigger) return;
    trigger.disabled = true;
    try {
      await refresh();
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = '';
    } catch {
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = cartItems.dataset.stockCheckFailed;
    } finally {
      trigger.disabled = false;
    }
  });
  form.addEventListener('submit', async event => {
    if (event.submitter?.name !== 'checkout') return;
    if (allowSubmit) { allowSubmit = false; return; }
    event.preventDefault();
    const checkout = getCheckout();
    if (!checkout || cartItems.getAttribute('aria-busy') === 'true') return;
    const label = checkout.textContent;
    checkout.disabled = true;
    checkout.textContent = cartItems.dataset.stockChecking;
    try {
      const updated = await refresh();
      if (!updated) throw new Error('Availability not verified');
      if (getStatus()?.dataset.cartStockBlocked === 'true' || checkout.disabled) {
        const issue = Array.from(cartItems.querySelectorAll('[data-cart-stock-key]'))
          .find(row => !row.querySelector('[data-cart-stock-message]')?.hidden);
        (issue?.querySelector('cart-remove-button a, cart-remove-button button, input[name="updates[]"]'))?.focus();
        return;
      }
      allowSubmit = true;
      form.requestSubmit(checkout);
    } catch {
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = cartItems.dataset.stockCheckFailed;
    } finally {
      checkout.textContent = label;
      checkout.disabled = getStatus()?.dataset.cartStockBlocked === 'true';
    }
  });
  checkWhenReturning();
})();
